import React from 'react';
import PageAncestor from 'core/common/page/pageAncestor';
import gridService from 'core/grid/gridService';
import GridCompConnected from 'core/grid/component/gridCompConnected';
import {ZzFlatButtonRoute} from "core/components/buttons/buttons";
import {MODULE, PERMISSION, PageProps} from "core/metamodel/metaConstant";
import {PAGE} from "routes";
import {observer} from "mobx-react";
import mdEntityService from "core/metamodel/mdEntityService";
import {CONTRACTSTATUS, CONTRACTTYPE} from "core/document/documentDomain";
import {loc} from "core/common/config/locales";

const gridLocation = 'contractList';

@observer
export default class ContractList extends PageAncestor<PageProps, undefined> {

  static module = MODULE.core;
  static title = loc.i18n`Contracts`;
  static icon = 'handshake-o';
  static rootPage = true;
  static protectedPage = true;


  static fetchData(routerParams) {
    console.log("ContractList#fetchData(%s)", gridLocation);
    return gridService.fetchGrids(gridLocation)
      .then(gl => gridService.getOrCreateGrid(gridLocation));
  }


  render() {
    let {params, query} = this.props;

    return (
        <GridCompConnected grid={gridService.getOrCreateGrid(gridLocation)} entities={mdEntityService.entityMap} gridId={params.gridId} query={query}>
          <ZzFlatButtonRoute onGridToolbar routeName="contractDetail" params={{id: 'new'}} query={{contractStatus: CONTRACTSTATUS.DRAFT, contractType: CONTRACTTYPE.CUSTOMER_CONTRACT}}
                             label={loc.i18n`New Contract`} permission={PERMISSION.New} securable={PAGE.contractDetail}/>
        </GridCompConnected>
    );
  }


}



// WEBPACK FOOTER //
// ./src/core/document/contractList.tsx